export const getVerifyCommand = (checksum?: string, sigFilename?: string) => {
    return `echo -n ${checksum} |
    cosign verify-blob --certificate-oidc-issuer https://oidc.eks.us-east-1.amazonaws.com/id/CCDCDBA1379A5596AB5B2E46DCA385BC \\
      --certificate-identity https://kubernetes.io/namespaces/freya-production/serviceaccounts/job-worker \\
      --bundle ${sigFilename} \\
      --new-bundle-format -`;
};
